export const ENTITY_UPDATE = "ENTITY_UPDATE";
export const ENTITY_CREATE = "ENTITY_CREATE";
export const ENTITY_DELETE = "ENTITY_DELETE";
